import React from "react";
import "./No_data.css";
import No_data_lottie from "../../Animation/No_data_lottie/No_data_lottie";

function No_data() {
  return (
    <>
      <section className="no-data">
        <No_data_lottie />
        No records found
      </section>
    </>
  );
}

export default No_data;
